var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHacksoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 247.305,
    height: 43.628,
    viewBox: "0 0 247.305 43.628",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f98211;}.b{fill:#918f8e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.06 12.36)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-70.06 -12.36)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M111.536,11.729V.1H88.64V7.55H80.1v18.9h21.987V36.26l-13.81-.182.182-3.634H80.1v10.9h31.436V19.361H88.822V7.732h13.992l-.182,4Z",
    transform: "translate(65.449 0.082)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M22.714,17.989H8.54V0H0V43.61H8.54V26.529H22.714V43.61h9.449V0H22.714Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M48.248,9.9H21.9V35.521H55.88V26.072H48.248ZM30.259,25.89V18.44h9.449v7.632Z",
    transform: "translate(17.894 8.089)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M43.7,9.9V35.521H70.229V26.072H52.24V18.44H70.229V9.9Z",
    transform: "translate(35.707 8.089)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M71.949,0H62.5V43.61h9.449V34.161h8.54V26.529h-8.54Z",
    transform: "translate(51.068)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 8.54,
    height: 8.522,
    transform: "translate(131.557 17.989)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 8.54,
    height: 9.467,
    transform: "translate(131.557 34.161)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(182.435 19.079)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M107.85,14.6H100.4V31.681h18.9l-.182-7.268H107.85Z",
    transform: "translate(-100.4 -7.15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M122.853,10.5H104.5v7.45h11.266v9.812h7.087Z",
    transform: "translate(-97.05 -10.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(213.508)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M117.5,3.5V40.75h8V20.762h7.45v-8.54H125.5V3.5Z",
    transform: "translate(-117.5 2.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.45,
    height: 6.396,
    transform: "translate(7.995)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M135.35,19.545h7.45l-.182-7.813h-7.632V4.1H127.9V33.537h7.45V40.26h7.268V32.81H135.35Z",
    transform: "translate(104.505 3.35)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHacksoft);
export default __webpack_public_path__ + "static/media/hacksoft.11b93442fe3508402f7873a03e229fe3.svg";
export { ForwardRef as ReactComponent };